import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

const selectDomain = (state) => state.agencyListing || initialState;

export const selectAgencies = createSelector(
  [selectDomain],
  (state) => state.agencies
);

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);

export const selectAgencyCount = createSelector(
  [selectDomain],
  (state) => state.agencyCount
);

export const selectTotalAgencies = createSelector(
  [selectDomain],
  (state) => state.totalAgencies
);
